const DEFAULT_LINKS = [
  { href: "#sobre", label: "Sobre" },
  { href: "#servicos", label: "Serviços" },
  { href: "#consorcio", label: "Consórcio" },
  { href: "#financiamento", label: "Financiamento" },
  { href: "#portfolio", label: "Portfólio" },
  { href: "#depoimentos", label: "Depoimentos" },
  { href: "#faq", label: "FAQ" },
  { href: "#contato", label: "Contato" },
];

const SECTION_KEY_MAP = {
  sobre: "about",
  servicos: "services",
  consorcio: "services",
  financiamento: "services",
  portfolio: "portfolio",
  depoimentos: "testimonials",
  faq: "faq",
  contato: "contact",
};

export function resolveNavLinks(navigation, enabledSections) {
  const links = (navigation || DEFAULT_LINKS).slice();

  if (!links.some((l) => l.href === "#faq")) {
    const idx = links.findIndex((l) => l.href === "#contato");
    if (idx >= 0) links.splice(idx, 0, { href: "#faq", label: "FAQ" });
    else links.push({ href: "#faq", label: "FAQ" });
  }

  return links.filter((l) => {
    if (!enabledSections) return true;
    const sectionKey = l.href.replace("#", "");
    const sk = SECTION_KEY_MAP[sectionKey] || sectionKey;
    return enabledSections[sk] !== false;
  });
}
